export const EMAIL = 'yeldynovn@gmail.com'

// Shown in the live clock. Change both together.
export const CITY = 'Kharkiv'
export const TIME_ZONE = 'Europe/Kyiv'

export const UPWORK = 'https://www.upwork.com/freelancers/~01666af90b1c137ab9'

export const SOCIALS = [
  { label: 'GitHub', href: 'https://github.com/yeldynov' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/yeldynov/' },
  { label: 'Upwork', href: UPWORK },
]
